import React from 'react';
import { Globe, Lock } from 'lucide-react';

const money = (n) =>
  `$${Number(n || 0).toLocaleString('en-US', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })}`;

/**
 * Side-by-side Internal vs External snapshot when viewing All channels.
 */
const ChannelSplitCards = ({ byChannel, className = '' }) => {
  const internal = byChannel?.internal || {};
  const external = byChannel?.external || {};

  if (!byChannel) return null;

  return (
    <div className={`grid grid-cols-1 gap-3 md:grid-cols-2 ${className}`.trim()}>
      <div className="rounded-xl border border-border bg-surface p-4 sm:p-5">
        <div className="mb-3 flex items-center gap-2">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-border bg-surface-muted text-ink">
            <Globe className="h-4 w-4" />
          </span>
          <div>
            <p className="text-sm font-semibold text-ink">Internal</p>
            <p className="text-[11px] text-ink-tertiary">Marketplace bookings &amp; payouts</p>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2 text-center sm:text-left">
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-wide text-ink-tertiary">Bookings</p>
            <p className="mt-0.5 text-lg font-semibold tabular-nums text-ink">
              {internal.bookings ?? 0}
            </p>
          </div>
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-wide text-ink-tertiary">Revenue</p>
            <p className="mt-0.5 text-lg font-semibold tabular-nums text-ink">
              {money(internal.revenue)}
            </p>
          </div>
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-wide text-ink-tertiary">Complete</p>
            <p className="mt-0.5 text-lg font-semibold tabular-nums text-ink">
              {Number(internal.completion_rate || 0).toFixed(0)}%
            </p>
          </div>
        </div>
      </div>

      <div className="rounded-xl border border-border bg-surface p-4 sm:p-5">
        <div className="mb-3 flex items-center gap-2">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-lg bg-gray-900 text-white">
            <Lock className="h-4 w-4" />
          </span>
          <div>
            <p className="text-sm font-semibold text-ink">External</p>
            <p className="text-[11px] text-ink-tertiary">Private bookings &amp; offline collected</p>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2 text-center sm:text-left">
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-wide text-ink-tertiary">Bookings</p>
            <p className="mt-0.5 text-lg font-semibold tabular-nums text-ink">
              {external.bookings ?? 0}
            </p>
          </div>
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-wide text-ink-tertiary">Collectible</p>
            <p className="mt-0.5 text-lg font-semibold tabular-nums text-ink">
              {money(external.revenue)}
            </p>
          </div>
          <div>
            <p className="text-[10px] font-semibold uppercase tracking-wide text-ink-tertiary">Paid</p>
            <p className="mt-0.5 text-lg font-semibold tabular-nums text-ink">
              {money(external.collected)}
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChannelSplitCards;
